import { AssistantDatasource } from "@core/data/datasources/assistant.datasource";
import {
    AssistantConversationCreatePayloadDto,
    AssistantConversationMessagePayloadDto,
    AssistantFeedbackPayloadDto,
} from "@core/data/dto/assistant.dto";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { AssistantConversation } from "@core/domain/models/assistant-conversation.model";
import { AssistantMessage } from "@core/domain/models/assistant-message.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class AssistantRepository {
    constructor(
        @inject(AssistantDatasource)
        private readonly datasource: AssistantDatasource,
    ) {}

    async fetchConversations(): Promise<
        Either<FallbackError, AssistantConversation[]>
    > {
        return this.datasource.fetchConversations();
    }

    async fetchConversation(
        id: number,
    ): Promise<Either<FallbackError, AssistantConversation>> {
        return this.datasource.fetchConversation(id);
    }

    async createConversation(
        payload?: AssistantConversationCreatePayloadDto,
    ): Promise<Either<FallbackError, AssistantConversation>> {
        return this.datasource.createConversation(payload);
    }

    async deleteConversation(id: number): Promise<Either<FallbackError, true>> {
        return this.datasource.deleteConversation(id);
    }

    async sendMessage(
        conversationId: number,
        payload: AssistantConversationMessagePayloadDto,
    ): Promise<
        Either<
            FallbackError,
            {
                conversation: AssistantConversation;
                userMessage: AssistantMessage;
                assistantMessage: AssistantMessage;
            }
        >
    > {
        return this.datasource.sendMessage(conversationId, payload);
    }

    async submitFeedback(
        messageId: number,
        payload: AssistantFeedbackPayloadDto,
    ): Promise<Either<FallbackError, AssistantMessage>> {
        return this.datasource.submitFeedback(messageId, payload);
    }
}
